import { render, staticRenderFns } from "./temperature-humidity.vue?vue&type=template&id=6a277306&scoped=true&"
import script from "./temperature-humidity.js?vue&type=script&lang=js&"
export * from "./temperature-humidity.js?vue&type=script&lang=js&"
import style0 from "./temperature-humidity.css?vue&type=style&index=0&id=6a277306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a277306",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
